import type { MessageInstance } from 'antd/es/message/interface'

// request.ts 拦截器里需要用 message，但拦截器跑在 React context 之外，
// 无法直接 useMessage()。通过这里中转：App.tsx 初始化时注入实例。
let _message: MessageInstance | null = null

export function setMessage(msg: MessageInstance) {
  _message = msg
}

export function getMessage(): MessageInstance {
  if (!_message) {
    throw new Error('message not initialized: call setMessage in App.tsx first')
  }
  return _message
}
